import { AppRoute } from '@app/core/routing/AppRoute';
import { RouteChildrenProps, Switch } from 'react-router-dom';
import { ManageAlertsPage } from './manage/ManageAlertsPage';

export function AlertsRoutes(props: RouteChildrenProps) {
  const { path } = props.match!;

  return (
    <Switch>
      <AppRoute path={`${path}`} component={ManageAlertsPage} />
    </Switch>
  );
}
